const parseAuth0StateParam = (state)=>{
    let isPasswordless = false;
    let email;
    try {
        if (typeof state === 'string') {
            const statePayload = JSON.parse(state);
            if (typeof statePayload === 'object' && 'type' in statePayload && 'email' in statePayload) {
                isPasswordless = statePayload.type === 'passwordless';
                email = statePayload.email;
            }
        }
    } catch (e) {}
    return {
        email,
        type: isPasswordless ? 'passwordless' : 'regular'
    };
};

export { parseAuth0StateParam };
//# sourceMappingURL=parse-auth0-state-param.js.map
